import { render, staticRenderFns } from "./AddMembers.vue?vue&type=template&id=04b42900"
import script from "./AddMembers.vue?vue&type=script&lang=js"
export * from "./AddMembers.vue?vue&type=script&lang=js"
import style0 from "./AddMembers.vue?vue&type=style&index=0&id=04b42900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports